import i18n from '@/plugins/i18n';

const eventsTableHeaders = () => [
  {
    key: 'activity',
    name: i18n.global.t('dbm.hardware.activity'),
    routable: false,
    width: '60%',
    dataType: 'String',
    rootKey: 'source',
    sortable: true,
  },
  {
    key: 'source',
    name: i18n.global.t('dbm.hardware.source'),
    width: '20%',
    routable: false,
    sortable: true,
  },
  {
    key: 'sourceElapsed',
    name: i18n.global.t('dbm.hardware.sourceElapsed'),
    routable: false,
    width: '20%',
    dataType: 'string',
    sortable: true,
  },
];

export { eventsTableHeaders };
